import { isEmpty } from 'lodash';

export default {
  percentages: {
    id: 'percentages',
    list: ['viewshare', 'completion', 'binge'],
    placeholder1of1: '0 - 100',
    placeholder1of2: '0 - 100',
    placeholder2of2: '0 - 100',
    normalize: value => (isEmpty(value) ? value : value / 100),
    denormalize: value => (isEmpty(value) ? value : value * 100)
  },
  positiveNumbers: {
    id: 'positiveNumbers',
    list: [
      'engagement',
      'followers',
      'views',
      'viewers',
      'affinity_index',
      'audience_overlap'
    ],
    placeholder1of1: 'Positive Number',
    placeholder1of2: 'Positive Number',
    placeholder2of2: 'Positive Number',
    normalize: value => value,
    denormalize: value => value
  },
  others: {
    id: 'others',
    list: [],
    placeholder1of1: 'Value',
    placeholder1of2: 'Min Value',
    placeholder2of2: 'Max Value',
    normalize: value => value,
    denormalize: value => value
  }
};
